import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const buttonVariants = cva("control-button", {
	variants: {
		variant: {
			default: "button-primary",
			destructive:
				"bg-destructive text-destructive-foreground shadow-control hover:bg-destructive/90",
			outline: "button-outline",
			secondary: "button-secondary",
			ghost: "button-ghost",
			link: "text-primary underline-offset-4 hover:underline",
		},
		size: {
			default: "h-11 px-4 py-2 md:h-10",
			sm: "h-11 rounded-md px-3 text-xs md:h-8",
			lg: "h-11 rounded-md px-8 md:h-10",
			icon: "size-11 md:size-10",
		},
	},
	defaultVariants: {
		variant: "default",
		size: "default",
	},
});

interface ButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
	asChild?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
	({ className, variant, size, asChild = false, ...props }, ref) => {
		const Comp = asChild ? Slot : "button";
		return (
			<Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
		);
	},
);
Button.displayName = "Button";

export { Button };
